import styled from '@emotion/styled'

export const StyledAvatarReviewer = styled.div`
  position: relative;
  img {
    border-radius: 50%;
  }
  .avatar {
    object-fit: cover;
  }
  .badge {
    position: absolute;
    right: 0;
    bottom: 0;
  }
`
